import get from 'lodash/get';

interface IRangeRef {
    current:{
        min: number,
        max: number
    }
}

export const getMinValue = (filter: Listing.IFilter) => get(filter, 'range.min', 0);
export const getMaxValue = (filter: Listing.IFilter) => get(filter, 'range.max', 0);
